import { getCurrentDate } from "~/mixins/formatting";

export const MetaTags = () => ({
  "bestellung-pellets": {
    title: "Pellets bestellen bei esyoil",
    meta: [
      { hid: "title", name: "title", content: "Pellets bestellen bei esyoil" },
      {
        hid: "image",
        name: "image",
        content: `###image###`,
      },
      {
        hid: "description",
        name: "description",
        content:
          "Pelletsvergleich bei esyoil, einfach günstig und den eigenen Pelletsanbieter sicher wechseln.",
      },
      { hid: "robots", name: "robots", content: "noindex, nofollow, noodp" },
    ],
  },
  "widerruf-pellets": {
    title: "Vertrag widerrufen | esyoil",
    meta: [
      { hid: "title", name: "title", content: "Vertrag widerrufen | esyoil" },
      {
        hid: "image",
        name: "image",
        content: `###image###`,
      },
      {
        hid: "description",
        name: "description",
        content:
          "Widerrufen Sie Ihre Pellets-Bestellung online über das Widerrufsformular von esyoil.",
      },
      { hid: "robots", name: "robots", content: "noindex, nofollow, noodp" },
    ],
  },
  "state-pages-pellets": {
    title:
      "Pelletspreise ###state### aktuell | Pelletspreise ###zipcode### ###state### heute vergleichen | Pellets kaufen",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletspreise ###state### aktuell | Pelletspreise ###zipcode### ###state### heute vergleichen | Pellets kaufen",
      },
      {
        hid: "image",
        name: "image",
        content: `###image###`,
      },
      {
        hid: "description",
        name: "description",
        content:
          "Pelletspreise ###state### aktuell ⭐ Pelletspreise ###state### heute ⭐ Holzpellets in ###zipcode### ###state### vergleichen & kaufen ✔️Tagesaktuelle Pelletpreise in der Nähe ✔️Günstig online bestellen ✔️Flexible Zahlarten",
      },
      { hid: "robots", name: "robots", content: "index,follow,noodp" },
      { name: "revisit-after", content: "1 days" },
      {
        name: "keywords",
        content:
          "Pelletspreise ###state###, Pellets ###state###, Holzpellets ###zipcode### ###state###",
      },
    ],
  },
  "state-overview": {
    title: "`Bundesländer in der Übersicht",
    meta: [
      { hid: "title", name: "title", content: "Bundesländer in der Übersicht" },
      {
        hid: "image",
        name: "image",
        content: `###image###`,
      },
      {
        hid: "description",
        name: "description",
        content:
          "Bundesländer in der Übersicht. Preise auf Bundeslandebene vergleichen.",
      },
    ],
  },

  "federal-states-pellets": {
    title:
      "Pelletspreise ###category### aktuell: regionale Anbieter vergleichen & heute Pellets kaufen",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletspreise ###category### aktuell: regionale Anbieter vergleichen & heute Pellets kaufen",
      },
      {
        hid: "image",
        name: "image",
        content: `###image###`,
      },
      {
        hid: "description",
        name: "description",
        content: `Pelletspreise ###category### aktuell am ${getCurrentDate()} ⭐ Holzpellets in ###category### vergleichen & kaufen ✔️ Tagesaktuelle Preise ✔️ Günstig online bestellen ✔️ Flexible Zahlarten`,
      },
      { hid: "robots", name: "robots", content: "index,follow,noodp" },
      { name: "revisit-after", content: "1 days" },
      {
        name: "keywords",
        content: "Pelletspreise ###category###, Holzpellets ###category###",
      },
    ],
  },

  "landkreis-pellets": {
    title:
      "Pelletspreise Landkreis ###name### aktuell: Jetzt in ###name### Pelletspreise vergleichen & Pellets kaufen",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletspreise Landkreis ###name### aktuell: Jetzt in ###name### Pelletspreise vergleichen & Pellets kaufen",
      },
      {
        hid: "image",
        name: "image",
        content: `###image###`,
      },
      {
        hid: "description",
        name: "description",
        content: `Pelletspreise Landkreis ###name### aktuell ⭐ Pelletspreise Landkreis ###name### heute am ${getCurrentDate()} ⭐ Holzpellets im Landkreis ###name### vergleichen & kaufen ✔️Tagesaktuelle Pelletpreise ✔️ Günstig online bestellen ✔️Flexible Zahlarten`,
      },
      { hid: "robots", name: "robots", content: "index,follow,noodp" },
      { name: "revisit-after", content: "1 days" },
      {
        name: "keywords",
        content: "Pelletspreise ###name###, Holzpellets ###name###",
      },
    ],
  },

  "district-city-pellets": {
    title:
      "Pelletspreise kreisfreie Stadt ###name### aktuell: Pelletspreise kreisfreie Stadt ###name### vergleichen & heute kaufen",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletspreise kreisfreie Stadt ###name### aktuell: Pelletspreise kreisfreie Stadt ###name### vergleichen & heute kaufen",
      },
      {
        hid: "image",
        name: "image",
        content: `###image###`,
      },
      {
        hid: "description",
        name: "description",
        content: `Pelletspreise kreisfreie Stadt ###name### aktuell ⭐ Pelletspreise kreisfreie Stadt ###name### heute am ${getCurrentDate()} ⭐ Pelletspreise in kreisfreier Stadt ###name### vergleichen & kaufen ✔️Tagesaktuelle Pelletspreise ✔️Günstig online bestellen ✔️Flexible Zahlarten`,
      },
      { hid: "robots", name: "robots", content: "index,follow,noodp" },
      { name: "revisit-after", content: "1 days" },
      {
        name: "keywords",
        content:
          "Pelletspreise kreisfreie Stadt ###name###, Pelletspreise kreisfreie Stadt ###name###, Pelletspreise kreisfreie Stadt ###name###",
      },
    ],
  },

  pellets: {
    title:
      "Pelletspreise aktuell: Pelletspreise vergleichen & günstig Pellets kaufen",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletspreise aktuell: Pelletspreise vergleichen & günstig Pellets kaufen",
      },
      {
        hid: "image",
        name: "image",
        content: `###image###`,
      },
      {
        hid: "description",
        name: "description",
        content:
          "Aktuelle Pelletspreise in der Nähe vergleichen ✚ Pellets kaufen ✔️ Günstige Holzpellets gibt es bei esyoil.",
      },
      {
        name: "keywords",
        content: "Pelletspreise, Pelletheizung, Pellets, Holzpellets",
      },
      { hid: "robots", name: "robots", content: "index,follow,noodp" },
      { name: "revisit-after", content: "1 days" },
    ],
  },
  "pellets-ratgeber": {
    title: "Pellets-Ratgeber: Pelletheizung, Qualität, Lagerung und Preise",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pellets-Ratgeber: Pelletheizung, Qualität, Lagerung und Preise",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Alle Ratgeber zu Holzpellets in der Übersicht: Pelletheizung, Pelletqualität und Zertifikate, Herstellung, Lagerung, Verbrauch und die Zusammensetzung des Pelletpreises.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pellets Ratgeber, Pelletheizung, Holzpellets Qualität, Pelletlager, Pelletsverbrauch",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pellets-sackware-lose-ware-vergleich": {
    title: "Sackware vs. Lose Pellets: Kosten, Vorteile & Vergleich",
    meta: [
      {
        hid: "title",
        name: "title",
        content: "Sackware vs. Lose Pellets: Kosten, Vorteile & Vergleich",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Holzpellets als Sackware oder lose Ware? Wir vergleichen Preis, Handling & Lagerung. Finden Sie die beste Wahl für Ihren Jahresverbrauch & sparen Sie Kosten!",
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "Holzpellets Sackware, lose Pellets kaufen, Pellets Vergleich",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pellets-herstellung": {
    title: "Wie werden Pellets hergestellt?",
    meta: [
      {
        hid: "title",
        name: "title",
        content: "Wie werden Pellets hergestellt?",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Detaillierter Ratgeber zur Pellet-Herstellung: Erfahren Sie, wie aus Holzabfällen hochwertige Pellets entstehen. Prozess, Rohstoffe & Verwertung von Restholz im Fokus.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "Pellets Rohstoffe, Pellets Prozess & Rohstoffherkunft",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  pelletsverbrauch: {
    title: "Pelletverbrauch berechnen: Formel, Faktoren & Spartipps",
    meta: [
      {
        hid: "title",
        name: "title",
        content: "Pelletverbrauch berechnen: Formel, Faktoren & Spartipps",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Ihren Pelletverbrauch präzise berechnen: Wir zeigen die Formeln für Neu- und Altbau, welche Faktoren den Verbrauch beeinflussen & geben bewährte Tipps zum Sparen.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "Pelletbedarf",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "holzpellets-preis-zusammensetzung": {
    title: "Holzpellets Preis Zusammensetzung: Kostenfaktoren & Kaufstrategie",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Holzpellets Preis Zusammensetzung: Kostenfaktoren & Kaufstrategie",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Transparente Analyse: Erfahren Sie, wie sich der Preis für Holzpellets zusammensetzt (Rohstoffe, Produktion, Logistik) und nutzen Sie saisonale Trends zum Sparen.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "Holzpellets Preis, Preisentwicklung Pellets, Pelletkauf",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "holzpellets-qualitaet": {
    title: "Holzpellets Qualität: ENplus A1, DINplus & Wichtige Parameter",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Holzpellets Qualität: ENplus A1, DINplus & Wichtige Parameter",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Hochwertige Holzpellets erkennen: Alle Infos zur ENplus A1 und DINplus Zertifizierung, Aschegehalt & Heizwert. So sichern Sie die Effizienz Ihrer Pelletheizung.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "Holzpellets Qualität, ENplus A1, Heizwert Pellets",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pellets-zertifikate": {
    title:
      "Pellets-Zertifikate: ENplus A1, DINplus, FSC und PEFC einfach erklärt",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pellets-Zertifikate: ENplus A1, DINplus, FSC und PEFC einfach erklärt",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Was bedeuten ENplus A1, DINplus, FSC und PEFC bei Holzpellets? Dieser Ratgeber erklärt die Unterschiede, Grenzwerte und worauf Sie beim Kauf achten sollten.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "Pellets Zertifikate, ENplus A1, DINplus, FSC, PEFC",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pelletheizung-asche": {
    title:
      "Asche bei der Pelletheizung: Entsorgung, Menge und Nutzung im Überblick",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Asche bei der Pelletheizung: Entsorgung, Menge und Nutzung im Überblick",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Wie viel Asche entsteht bei einer Pelletheizung? Wann den Aschekasten leeren, wie richtig entsorgen und was bei Gartennutzung zu beachten ist. Fachlich erklärt.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pelletheizung Asche, Pelletasche entsorgen, Pelletasche Garten",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  pelletsheizung: {
    title:
      "Pelletheizung Arten: Zentralheizung, Pelletofen & Kombigerät Vergleich",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletheizung Arten: Zentralheizung, Pelletofen & Kombigerät Vergleich",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Die passende Pelletheizung finden: Wir vergleichen Pelletofen, halb- & vollautomatische Pelletszentralheizungen. So wählen Sie die beste Lösung für Ihr Zuhause.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "Pelletheizung Arten, Pelletofen, Pelletszentralheizung",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pelletlager-reinigung": {
    title: "Pelletlager Reinigung: Ablauf, Kosten & Tipps für saubere Pellets",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletlager Reinigung: Ablauf, Kosten & Tipps für saubere Pellets",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Wann und wie Sie Ihr Pelletlager reinigen (lassen) sollten: Alles zu Ablauf, Kosten (ab 300 €), Sicherheitsvorkehrungen und der optimalen Häufigkeit.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pelletlager Reinigung, Pelletbunker reinigen, Pelletlager Kosten",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  pelletlager: {
    title: "Pelletlager Planung: Größe, Standort & Arten (Silo, Bunker, Tank)",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletlager Planung: Größe, Standort & Arten (Silo, Bunker, Tank)",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Alles zur optimalen Pelletlagerung: Größe berechnen, Standortanforderungen & Vergleich der Lagertypen (Silo, Bunker, Tank). Inkl. Brandschutz & Sicherheitstipps.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pelletlager Größe berechnen, Pelletlager Arten, Pelletlager Planung",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pelletheizung-vorteile-nachteile": {
    title: "Pelletheizung Vor- & Nachteile: Kosten, Lagerbedarf & Emissionen",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletheizung Vor- & Nachteile: Kosten, Lagerbedarf & Emissionen",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Die ehrliche Bilanz: Alle Pelletheizung Vorteile (Kosten, Emissionen) und Nachteile (Anschaffungskosten, Platzbedarf) im Detail. Fundierte Entscheidungshilfe.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pelletheizung Vorteile, Pelletheizung Nachteile, Pelletlager Platzbedarf",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "heizwert-pellets": {
    title: "Heizwert Pellets: kWh/kg, Vergleich & Berechnung des Verbrauchs",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Heizwert Pellets: kWh/kg, Vergleich & Berechnung des Verbrauchs",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Der Heizwert von Pellets (Ø 4,8 kWh/kg) erklärt: Vergleich zu Gas/Öl, der Unterschied zum Brennwert & die Formel zur Berechnung Ihres jährlichen Pelletbedarfs.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Heizwert Pellets, Pelletverbrauch berechnen, Brennwert Pellets",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pelletheizung-wartung-kosten": {
    title:
      "Pelletheizung Wartung: Was gemacht wird, was es kostet und was Pflicht ist",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletheizung Wartung: Was gemacht wird, was es kostet und was Pflicht ist",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Pelletheizung warten: Jahresinspektion, Schornsteinfegerpflicht, Eigenleistungen und alle Kosten im Überblick. Mit konkreten Preisangaben für Wartungsvertrag und Einzelauftrag.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pelletheizung Wartung, Pelletheizung Kosten, Wartungsvertrag Pelletkessel",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "oel-auf-pellets": {
    title: "Von Öl auf Pellets umsteigen: Schritt-für-Schritt-Anleitung",
    meta: [
      {
        hid: "title",
        name: "title",
        content: "Von Öl auf Pellets umsteigen: Schritt-für-Schritt-Anleitung",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Wer von Öl auf Pellets wechselt, hat strukturelle Vorteile gegenüber anderen Heizungswechseln. Ablauf, Kosten, Schornstein, Öltank und KfW-Förderung erklärt.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Öl auf Pellets umsteigen, Pelletheizung einbauen, KfW Förderung Pellets",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "gas-auf-pellets": {
    title: "Von Gas auf Pellets umsteigen: Schritt-für-Schritt-Anleitung",
    meta: [
      {
        hid: "title",
        name: "title",
        content: "Von Gas auf Pellets umsteigen: Schritt-für-Schritt-Anleitung",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Wer von Gas auf Pellets wechselt, steht vor anderen Herausforderungen als beim Ölwechsel: kein Tank, kein freier Kellerraum, oft kein klassischer Schornstein. Alle Schritte erklärt.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Gas auf Pellets umsteigen, Pelletheizung einbauen, KfW Förderung Pellets Gas",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pelletlager-selbst-bauen": {
    title:
      "Pelletlager selbst bauen: Planung, Anforderungen und was Fachleute übernehmen müssen",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletlager selbst bauen: Planung, Anforderungen und was Fachleute übernehmen müssen",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Wer ein Pelletlager selbst bauen möchte, kann viele Arbeiten in Eigenleistung erbringen, aber nicht alle. Statik, Belüftung, Brandschutz und Befüllsystem erklärt.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pelletlager selbst bauen, Pelletlager Kellerraum, Pelletlager Schrägboden, Pelletlager Anforderungen",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pelletofen-zusatzheizung": {
    title: "Pelletofen als Zusatzheizung: Wann es sich lohnt und wann nicht",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletofen als Zusatzheizung: Wann es sich lohnt und wann nicht",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Ein Pelletofen als Zusatzheizung klingt attraktiv, rechnet sich aber nicht immer. Wann die Investition sinnvoll ist, wann nicht und welche Alternativen es gibt.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pelletofen Zusatzheizung, Pelletofen Kosten, Pelletofen lohnt sich, Pelletofen Ersparnis",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pelletofen-vs-pelletheizung": {
    title: "Pelletofen vs. Pelletheizung: Was ist der Unterschied?",
    meta: [
      {
        hid: "title",
        name: "title",
        content: "Pelletofen vs. Pelletheizung: Was ist der Unterschied?",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Pelletofen oder Pelletheizung: was passt zu Ihrem Haus? Unterschiede bei Aufbau, Leistung, Lagerung, Kosten und Förderung verständlich erklärt.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pelletofen, Pelletheizung, Pelletofen vs Pelletheizung, wasserführender Pelletofen, Unterschied Pelletofen Pelletkessel",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pelletheizung-wirkungsgrad": {
    title: "Pelletheizung Wirkungsgrad: Was bedeutet das für Ihre Heizkosten?",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletheizung Wirkungsgrad: Was bedeutet das für Ihre Heizkosten?",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Wirkungsgrad vs. Jahresnutzungsgrad bei der Pelletheizung: Was die Zahlen wirklich bedeuten, warum Herstellerangaben trügen können und wie Sie den tatsächlichen Verbrauch berechnen.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pelletheizung Wirkungsgrad, Jahresnutzungsgrad Pelletkessel, Brennwerttechnik Pellets",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pellets-services": {
    title: "Pellets bestellen: Lieferung, Mindestbestellmenge und Zahlarten",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pellets bestellen: Lieferung, Mindestbestellmenge und Zahlarten",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Was Sie vor, während und nach der Pelletlieferung wissen sollten: Ablauf der Lieferung, Lieferformen, Mindestbestellmenge und übliche Zahlarten im Überblick.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pellets bestellen, Pelletlieferung, Mindestbestellmenge Pellets, Zahlarten Pellets",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  pelletlieferung: {
    title: "Pelletlieferung: Ablauf, Vorbereitung und Tipps für den Liefertag",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pelletlieferung: Ablauf, Vorbereitung und Tipps für den Liefertag",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Wie läuft eine Pelletlieferung ab? Technischer Ablauf, Anforderungen an Zufahrt und Lagerraum, Checkliste für den Liefertag und Sicherheitshinweise im Überblick.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pelletlieferung, Pellets liefern lassen, Pellets Liefertag Vorbereitung",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  "pellets-bestellen": {
    title: "Wie viele Pellets bestellen? Bedarfsrechner und Entscheidungshilfe",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Wie viele Pellets bestellen? Bedarfsrechner und Entscheidungshilfe",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Wie viele Pellets Sie bestellen sollten, hängt von Lagerkapazität, aktuellem Füllstand, Jahreszeit und Preisentwicklung ab. Schritt-für-Schritt-Rechner und Entscheidungshilfe.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pellets bestellen, Pelletbedarf berechnen, wie viele Pellets kaufen",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  zahlarten: {
    title:
      "Pellets kaufen: Welche Zahlarten sind beim Pellets-Preisvergleich möglich?",
    meta: [
      {
        hid: "title",
        name: "title",
        content:
          "Pellets kaufen: Welche Zahlarten sind beim Pellets-Preisvergleich möglich?",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Welche Zahlarten gibt es beim Pelletskauf über esyoil? Barzahlung, EC-Karte, Rechnung, Lastschrift und Vorkasse im Überblick. Mit allen wichtigen Details.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Pellets Zahlarten, Pellets kaufen bezahlen, Pelletskauf Rechnung Lastschrift",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
  mindestbestellmenge: {
    title: "Mindestbestellmenge bei Pellets: Was wirklich gilt",
    meta: [
      {
        hid: "title",
        name: "title",
        content: "Mindestbestellmenge bei Pellets: Was wirklich gilt",
      },
      {
        hid: "description",
        name: "description",
        content:
          "Gibt es eine Mindestbestellmenge bei Pellets? Was Händler verlangen, warum lose Ware und Sackware unterschiedliche Regeln haben und was Kleinmengen kosten.",
      },
      {
        hid: "keywords",
        name: "keywords",
        content:
          "Mindestbestellmenge Pellets, Pellets Kleinmenge, Pellets lose Ware Mindestmenge",
      },
      {
        hid: "robots",
        name: "robots",
        content: "index,follow,noodp",
      },
    ],
  },
});
